import { useState, useEffect, useRef } from 'react';

const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) {
      setIsLoaded(true);
      return;
    }

    const scriptId = 'google-maps-script';
    const existingScript = document.getElementById(scriptId);

    if (existingScript) {
      if (window.google && window.google.maps) {
        setIsLoaded(true);
        isInitialized.current = true;
      } else {
        existingScript.addEventListener('load', () => {
          setIsLoaded(true);
          isInitialized.current = true;
        });
        existingScript.addEventListener('error', () => {
          setLoadError('Failed to load Google Maps API');
        });
      }
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_REACT_GOOGLE_MAP_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setIsLoaded(true);
      isInitialized.current = true;
      setLoadError(null);
    };

    script.onerror = () => {
      setLoadError('Failed to load Google Maps API');
    };

    document.head.appendChild(script);

    return () => {
      if (!isInitialized.current) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return { isLoaded, loadError };
};

export default useGoogleMaps;
